var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6DFF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(14 14)",
    fill: "#D6DFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.918 35.9896C17.4219 36.0185 16.9341 35.8536 16.5573 35.5297C15.8142 34.7822 15.8142 33.575 16.5573 32.8275L32.828 16.5567C33.6009 15.8335 34.8136 15.8737 35.5368 16.6466C36.1908 17.3455 36.2289 18.4197 35.626 19.1631L19.2595 35.5297C18.8875 35.8489 18.4075 36.0135 17.918 35.9896Z",
    fill: "#1E4793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1698 35.9897C33.6671 35.9875 33.1852 35.788 32.8283 35.4339L16.5575 19.1631C15.8691 18.3591 15.9627 17.1493 16.7666 16.4608C17.4841 15.8464 18.5423 15.8464 19.2597 16.4608L35.6263 32.7316C36.399 33.455 36.4389 34.6678 35.7155 35.4405C35.6868 35.4712 35.657 35.5009 35.6263 35.5297C35.2255 35.8782 34.6981 36.0447 34.1698 35.9897Z",
    fill: "#1E4793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyCancel);
export default __webpack_public_path__ + "static/media/notifyCancel.af12896350fe53ae03f646da76688345.svg";
export { ForwardRef as ReactComponent };